import React, { useState, useContext, useEffect } from "react";
import "./Reporting.scss";
import { useSelector } from "react-redux";
import BlockedBotTypeBreakdownCards from "./ReportingComponents/BlockedBotTypeBreakdownCards";
import ReportingLargeDataTable from "./ReportingComponents/ReportingLargeDataTable";
import OverallThreatLevel from "./ReportingComponents/OverallThreatLevel";
import BlockedBotThreatLevel from "./ReportingComponents/BlockedBotThreatLevel";
import ReportingCountriesTable from "./ReportingComponents/ReportingCountriesTable";
import ReportingSelecterBar from "./ReportingComponents/ReportingSelecterBar";
import { getReportingResultsTableData } from "./ReportingDataController/ReportingDataController";
import { Context } from "react-zoom-pan-pinch";
import BotSelectorBox from "./ReportingComponents/Shared/BotSelectorBox";
import Loader from "../../SharedComponents/Loader/Loader";
export const ReportingContext = React.createContext();

const Reporting = () => {
	const [loading, setLoading] = useState(true);
	const [reportTableData, setReportTableData] = useState(false);
	//Redux variables
	const websiteThreatAssessment = useSelector((state) => state?.botActivityBotRiskDetails?.data?.websiteThreatAssessment);
	const websiteRiskData = useSelector(state => state?.botActivityBotRiskDetails?.data);
	const finishedSessionsData = useSelector(state => state?.finishedSessions?.data || []);
	const blockedSessionsGeographyData = useSelector(state => state?.blockedSessionsGeography?.data);
	//Shared States	
	const [page, setPage] = useState(1);
	//Filter States
	const [botTypesToShow, setBotTypesToShow] = useState(new Map());
	const [botCountriesToShow, setBotCountriesToShow] = useState(new Map());
	const [botThreatsToShow, setBotThreatsToShow] = useState(new Map());
	//other States

	const [timeRange, setTimeRange] = useState({ timeRange: "Prev 7 Days" });

	const updateTable = () => {
		asyncWrapper();
	};
	//First Render UseEffect
	useEffect(() => {
		if (loading === true) {
			asyncWrapper()
		}
	}, [loading]);

	React.useEffect(() => {
		asyncWrapper();
	}, [page]);

	const asyncWrapper = async () => { console.log("async FunkCalled: ", botTypesToShow); setReportTableData(await getReportingResultsTableData({ timeRange, botTypesToShow, botCountriesToShow, botThreatsToShow, page })); setLoading(false); };


	if (loading || reportTableData === false) {
		return (
			<div className="loading">
				<Loader />
			</div>
		);
	};

	return (
		<div className="reporting-container">
			<div className="Reporting">
				<div className="reporting header">
					<h1>Reporting</h1>
					<div className="reporting title-bar">
						<ReportingSelecterBar timeRange={timeRange} setTimeRange={setTimeRange} />
					</div>
					<BotSelectorBox botsToShow={botTypesToShow} setBotsToShow={setBotTypesToShow} setLoading={setLoading} header="Type" className="type" />
					<BotSelectorBox botsToShow={botThreatsToShow} setBotsToShow={setBotThreatsToShow} setLoading={setLoading} header="Threat Level" className="threat-level" />
					<BotSelectorBox botsToShow={botCountriesToShow} setBotsToShow={setBotCountriesToShow} setLoading={setLoading} header="Country" className="country" />
					<button className="reporting update-table-button" onClick={() => setLoading(true)}>Update filters</button>
				</div>

				<div className="reporting bot-type-breakdown">
					<BlockedBotTypeBreakdownCards websiteThreatAssessment={websiteThreatAssessment} botTypesToShow={botTypesToShow} setBotTypesToShow={setBotTypesToShow} setLoading={setLoading} />
				</div>

				<div className="reporting bot-threat-time">
					<OverallThreatLevel websiteRiskData={websiteRiskData} finishedSessionsData={finishedSessionsData} botThreatsToShow={botThreatsToShow} setBotThreatsToShow={setBotThreatsToShow} />
				</div>
				<div className="reporting bot-threat-radial">
					<BlockedBotThreatLevel botThreatsToShow={botThreatsToShow} setBotThreatsToShow={setBotThreatsToShow} setLoading={setLoading} />
				</div>
				<div className="reporting bot-by-country">
					<ReportingCountriesTable blockedSessionsGeographyData={blockedSessionsGeographyData} botCountriesToShow={botCountriesToShow} setBotCountriesToShow={setBotCountriesToShow} setLoading={setLoading} />
				</div>
				<div className="reporting bot-details">
					<ReportingLargeDataTable data={reportTableData} page={page} setPage={setPage} queryDetails={{ timeRange, botTypesToShow, botCountriesToShow, botThreatsToShow }} />
				</div>
			</div>
	</div>
	
	);
};

export default Reporting;